import VirtualBackgroundExtension from "agora-extension-virtual-background";

const extension = new VirtualBackgroundExtension();

export const Extension = extension